var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"timeout":_vm.duration},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('span',{staticClass:"ml-4",domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('v-btn',{attrs:{"small":"","outlined":"","color":"primary"},on:{"click":_vm.destroyVm}},[_vm._v(_vm._s(_vm.btnText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }